/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { Select } from '../../core-ui/Select';
import ensureObject from '../../support/shared/ensureObject';

type Style = {
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
};

type Props<T> = {
  selectedItem?: T;
  isSelected?: (item: T) => boolean;
  onChange: (item: T) => void;
  options: Array<T>;
  getDisplayName?: (item: T) => string;
  isDisabled?: boolean;
  style?: Style;
  width?: number;
  maxWidth?: number;
};

export default function Picker<T>(props: Props<T>) {
  const {
    selectedItem,
    isSelected,
    options,
    isDisabled,
    onChange,
    style,
    width,
    maxWidth,
  } = props;
  const renderLabel = props.getDisplayName ?? getDisplayName;
  return (
    <Select
      options={options}
      value={selectedItem}
      isSelected={isSelected}
      getLabel={(item) => renderLabel(item)}
      onChange={onChange}
      isDisabled={isDisabled}
      rootProps={{ style, maxWidth }}
      size="md"
      width={width ?? 'auto'}
      maxWidth={maxWidth}
      height="34px"
      fontSize="14px"
      backgroundColor="white"
      borderColor="rgb(202, 205, 208)"
      borderRadius="3px"
    />
  );
}

function getDisplayName(item: any) {
  let object = ensureObject(item);
  if (object) {
    return typeof object.name === 'string' ? object.name : '';
  }
  return item == null ? '' : String(item);
}
